import React from 'react';
//import PropTypes from 'prop-types';
import classnames from 'classnames';
import { translate } from 'react-i18next';
import i18next from 'i18next';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AddToCalendarHOC from 'react-add-to-calendar-hoc';

import FundkyButton from 'Parts/ui/components/FundkyButton';
import BuyTicketBtn from './BuyTicketBtnContainer';

import PublicEventInfo_en from './locales/PublicEventInfo_en.json';
import PublicEventInfo_fr from './locales/PublicEventInfo_fr.json';

import './PublicEventInfo.less';

class PublicEventInfo extends React.Component {
  constructor(props) {
    super(props);

    props.fetchEvent(props.entity.id, false, { showLocation: true, showSettings: true });

    this.calendarModalRef = React.createRef();

    i18next.addResourceBundle('en', 'PublicEventInfo', PublicEventInfo_en);
    i18next.addResourceBundle('fr', 'PublicEventInfo', PublicEventInfo_fr);
  }

  getDate = (date, locale) => {
    let d, j, m, c, t, sm;

    d = moment(date);
    m = d
      .lang(locale)
      .format('MMMM')
      .toUpperCase();
    j = d.lang(locale).format('DD');
    t = d.lang(locale).format('LT');
    t = t === "00:00"
      ? null
      : t;
    c = d
      .startOf('day')
      .lang(locale)
      .format('LLLL')
      .replace(' 12:00 AM', '')
      .replace(' 00:00', '');
    c = c.charAt(0).toUpperCase() + c.slice(1);
    sm = m.length > 7
      ? ' smalled'
      : '';

    return {
      date: moment(date),
      month: m,
      day: j,
      complete: c,
      time: t,
      smalled: sm
    };
  };

  getLocation = loc => {
    return {
      lines: [
        loc.name,
        `${loc.address}${loc.unit && `, ${loc.unit}`}`,
        `${loc.city}, ${loc.province} ${loc.postalCode}`
      ],
      full: `${loc.address} ${loc.city} ${loc.province} ${loc.postalCode}`
    };
  };

  render() {
    const { props, getDate, getLocation, handleShowModal } = this,
      { t, locale, compact, className, entity, Event } = props,
      { event, isFetchEventInProgress } = Event;

    let dateOn, dateOff, location;
    if (!isFetchEventInProgress) {
      dateOn = getDate(event.startOn, locale);
      if (event.endOn) dateOff = getDate(event.endOn, locale);
      if (event.location) location = getLocation(event.location);
    }

    const computedClassName = classnames('PublicEventInfo', className, {
      'PublicEventInfo--Compact': compact
    });

    const calendarButton = ({ children, onClick }) => {
      return (
        <FundkyButton
          text={t('add-to-calendar')}
          icon={['far', 'calendar-plus']}
          iconPosition="before"
          type="text"
          action={{ func: onClick }}
        />
      );
    };

    const calendarDropdown = ({ children }) => {
      return <div className="PublicEventInfo__CalendarDropdown">{children}</div>;
    };

    const AddToCalendar = AddToCalendarHOC(calendarButton, calendarDropdown);

    const calendarEvent = dateOn &&
      dateOff &&
      location &&
      entity && {
        title: entity.name,
        description: entity.description.description,
        startDatetime: dateOn.date.format('YYYYMMDDTHHmmss') + 'Z',
        endDatetime: dateOff.date.format('YYYYMMDDTHHmmss') + 'Z',
        duration: moment
          .duration(dateOff.date.diff(dateOn.date))
          .asHours()
          .toString(),
        //timezone: 'America/Montreal',
        location: location.full
      };

    return (
      <div className={computedClassName}>
        <div className="PublicEventInfo__Container">
          { event.startOn &&
          <div className={`PublicEventInfo__Date${dateOn && dateOn.smalled}`}>
            {!isFetchEventInProgress && dateOn && (
              <>
                <span>{dateOn.month}</span>
                <span>{dateOn.day}</span>
              </>
            )}
          </div>
          }
          <div className="PublicEventInfo__Infos">
            {/* <div className="PublicEventInfo__Location PublicEventInfo--li">
              <FontAwesomeIcon icon={['fas', 'map-marker-alt']} />
              <div>
                {location && (
                  <>
                    <span>{location.lines[0]}</span>
                    <span>{location.lines[1]}</span>
                    <span>{location.lines[2]}</span>
                  </>
                )}
              </div>
            </div> */}
            {event.startOn &&
            <div className="PublicEventInfo__Time PublicEventInfo--li">
              <FontAwesomeIcon icon={['fas', 'alarm-clock']} />
              {dateOn && (
                <div>
                  <span>
                    {dateOn.complete}
                    {dateOff && dateOn.complete !== dateOff.complete && ` ― ${dateOff.complete}`}
                  </span>
                  {dateOn.time && (
                    <span>
                      {dateOn.time}
                      {dateOff && dateOff.time && dateOn.time !== dateOff.time && ` ― ${dateOff.time}`}
                    </span>
                  )}
                </div>
              )}
            </div>
            }
          </div>
        </div>
        <div className="PublicEventInfo__CTA">
          <BuyTicketBtn
            template="button"
            plural={false}
          />
          {dateOn && dateOff && location && entity && (
            <>
              <span>{t('or')}</span>
              <AddToCalendar event={calendarEvent} />
            </>
          )}
        </div>
      </div>
    );
  }
}

PublicEventInfo.defaultProps = {};

PublicEventInfo.propTypes = {};

export default translate('PublicEventInfo')(PublicEventInfo);
